import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useLang } from "@/i18n/translations";
import api from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { clear } = useCart();
  const { t } = useLang();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); clear(); return; }
        if (data.status === "expired" || attempts > 8) { setStatus("error"); return; }
      } catch { if (attempts > 8) { setStatus("error"); return; } }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId, clear]);

  return (
    <div className="pt-40 pb-40 min-h-screen">
      <div className="max-w-lg mx-auto px-5 text-center card-dark rounded-2xl p-12" data-testid="payment-success-page">
        {status === "checking" && (<><Loader2 className="w-14 h-14 text-gold mx-auto mb-6 animate-spin" /><p className="text-xl">{t({ fr: "Vérification du paiement…", en: "Verifying payment…" })}</p></>)}
        {status === "paid" && (<>
          <CheckCircle2 className="w-16 h-16 text-emerald-accent mx-auto mb-6" />
          <h1 className="font-serif text-3xl mb-3">{t({ fr: "Paiement confirmé !", en: "Payment confirmed!" })}</h1>
          <p className="text-cream/60 mb-8">{t({ fr: "Merci pour votre commande.", en: "Thank you for your order." })}</p>
          <Link to="/boutique" className="btn-gold rounded-full px-8 py-4">{t({ fr: "Retour à la boutique", en: "Back to shop" })}</Link>
        </>)}
        {status === "error" && (<>
          <XCircle className="w-16 h-16 text-crimson-accent mx-auto mb-6" />
          <h1 className="font-serif text-3xl mb-3">{t({ fr: "Paiement non confirmé", en: "Payment not confirmed" })}</h1>
          <Link to="/boutique" className="btn-outline-gold rounded-full px-8 py-4 mt-4 inline-block">{t({ fr: "Retour à la boutique", en: "Back to shop" })}</Link>
        </>)}
      </div>
    </div>
  );
}
